import { Component } from '@angular/core';
import { ClassifierComponent } from 'components/classifier/classifier.component';
import { ClassifierListItem, UpdateClassifierRequest, ClassifierByIdCard, CreateClassifierValueRequest } from 'types/classifier.interface';

import { BreadcrumbsComponent } from 'components/breadcrumbs/breadcrumbs.component';
import { Breadcrumb } from 'types/breadcrumb.interface';
import { TranslateModule } from '@ngx-translate/core';
import { ApiService } from 'services/api.service';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { ToastService } from 'services/toast.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-classifier-page',
  standalone: true,
  imports: [ClassifierComponent, BreadcrumbsComponent, TranslateModule, SpinnerComponent, FormsModule],
  templateUrl: './classifier-page.component.html',
  styleUrl: './classifier-page.component.scss'
})
export class ClassifierPageComponent {
  classifiers: ClassifierListItem[] = [];
  isLoading = true;
  isClassifierCrudLoading = false;
  searchTerm: string = '';

  breadcrumbs: Breadcrumb[] = [
    {
      title: 'components.breadcrumbs.admin',
      url: ''
    },
    {
      title: 'components.breadcrumbs.classifiers',
      url: '/klasifikatori'
    }
  ];

  constructor(
    private apiService: ApiService,
    private toastService: ToastService
  ) {
    this.getClassifiers();
  }

  getClassifiers() {
    this.apiService.getAllClassifiers(this.searchTerm).subscribe(
      (classifiers: ClassifierListItem[]) => {
        this.classifiers = classifiers;
        this.classifiers.sort((a: ClassifierListItem, b: ClassifierListItem) => a.name!.localeCompare(b.name!));
        this.isLoading = false;
      },
      (error: any) => {
        this.toastService.showRequestError();
        this.isLoading = false;
        console.error('Error loading classifiers:', error);
      }
    );
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.getClassifiers();
  }

  handleKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.getClassifiers();
    }
  }

  editClassifier(classifier: UpdateClassifierRequest): void {
    this.isClassifierCrudLoading = true;
    this.apiService.editClassifier(classifier).subscribe(
      (updatedClassifier: ClassifierByIdCard) => {
        const index = this.classifiers.findIndex((c: ClassifierListItem) => c.code === updatedClassifier.code);
        this.classifiers[index] = {
          ...this.classifiers[index],
          ...updatedClassifier
        };
        this.isClassifierCrudLoading = false;
        this.toastService.showSuccess('editClassifierSuccess', '', {
          shouldTranslate: true
        });
      },
      (error: any) => {
        this.toastService.showRequestError();
        this.isClassifierCrudLoading = false;
        console.error('Error updating classifier:', error);
      }
    );
  }

  addClassifierValue(classifierValue: CreateClassifierValueRequest): void {
    this.isClassifierCrudLoading = true;

    this.apiService.addClassifierValue(classifierValue).subscribe(
      () => {
        const index = this.classifiers.findIndex((c: ClassifierListItem) => c.id === classifierValue.classifierId);

        if (index !== -1 && this.classifiers[index]) {
          if (this.classifiers[index].count && typeof this.classifiers[index].count === 'number') {
            this.classifiers[index].count = (this.classifiers[index].count || 0) + 1;
          }
        }

        this.isClassifierCrudLoading = false;
        this.toastService.showSuccess('addClassifierSuccess', '', {
          shouldTranslate: true
        });
      },
      (error: any) => {
        this.isClassifierCrudLoading = false;
        this.toastService.showRequestError();
        console.error('Error adding classifier value:', error);
      }
    );
  }
}
